import React from 'react';
import { HomeIcon, MoneyIcon } from '@nimbus-ds/icons';
import { NavTabs } from '@nimbus-ds/patterns';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Text, Tooltip } from '@nimbus-ds/components';
import { useTranslation } from 'react-i18next';

const NavButtons: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleGoTo = (page: string) => navigate(page);
  const items = [
    {
      path: '/',
      labelKey: 'Configurações',
      helperKey: 'Configurações do sistema',
      icon: <HomeIcon size="medium" />,
    },
  ];
  const defaultItems = [
    {
      path: '/billing',
      labelKey: 'Components.NavButtons.Billing.Label',
      helperKey: 'Components.NavButtons.Billing.Helper',
      icon: <MoneyIcon size="medium" />,
    },
  ];

  return (
    <NavTabs>
      {[...items, ...defaultItems].map((item) => (
        <NavTabs.Item
          key={item.path}
          active={pathname === item.path}
          ariaLabel={t(item.labelKey)}
          icon={
            <Box
              as="span"
              display={'grid'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Box
                as="span"
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
              >
                <Tooltip content={t(item.helperKey)} position="top">
                  {item.icon}
                </Tooltip>
              </Box>
              <Text textAlign={'center'}>{t(item.labelKey)}</Text>
            </Box>
          }
          onClick={() => handleGoTo(item.path)}
        />
      ))}
      {/* <NavTabs.Item
        active={pathname === '/'}
        ariaLabel={`${t('Components.NavButtons.Home.Label')}`}
        icon={
          <Tooltip
            content={`${t('Components.NavButtons.Home.Helper')}`}
            position="top"
          >
            <HomeIcon size="medium" />
          </Tooltip>
        }
        onClick={() => {
          handleGoToConfigs('/');
        }}
      />
      <NavTabs.Item
        active={pathname === '/statistics'}
        ariaLabel={`${t('StatisticsPage.title')}`}
        icon={
          <Tooltip content={`${t('StatisticsPage.title')}`} position="top">
            <StatsIcon size="medium" />
          </Tooltip>
        }
        onClick={() => {
          handleGoToConfigs('/statistics');
        }}
      />
      <NavTabs.Item
        active={pathname === '/block-products'}
        ariaLabel={`${t('Components.NavButtons.BlockProducts.Label')}`}
        icon={
          <Tooltip
            content={`${t('Components.NavButtons.BlockProducts.Helper')}`}
            position="top"
          >
            <ForbiddenIcon size="medium" />
          </Tooltip>
        }
        onClick={() => {
          handleGoToConfigs('/block-products');
        }}
      />
      <NavTabs.Item
        active={pathname === '/configs'}
        ariaLabel={`${t('Components.NavButtons.Configs.Label')}`}
        icon={
          <Tooltip
            content={`${t('Components.NavButtons.Configs.Helper')}`}
            position="top"
          >
            <CogIcon size="medium" />
          </Tooltip>
        }
        onClick={() => {
          handleGoToConfigs('/configs');
        }}
      />
      <NavTabs.Item
        active={pathname === '/billing'}
        ariaLabel={`${t('Components.NavButtons.Billing.Label')}`}
        icon={
          <Tooltip
            content={`${t('Components.NavButtons.Billing.Helper')}`}
            position="top"
          >
            <MoneyIcon size="medium" />
          </Tooltip>
        }
        onClick={() => {
          handleGoToConfigs('/billing');
        }}
      /> */}
    </NavTabs>
  );
};

export default NavButtons;
